// extracted by mini-css-extract-plugin
module.exports = {"active":"DealStatusTag_active__39n3P","draft":"DealStatusTag_draft__7fYSF"};